<div *ngIf="step !== 2 && !loading" class="general-container flex flex-col h-full items-center justify-between" id="sign_up_page">
    <div class="register-welcome flex flex-col w-full justify-center items-center">
        <div class="flex flex-col justify-center items-center content-center" *ngIf="step === 0">
            <div class="step pwd">
                <div class="header">
                    <img class="w-[288px] h-[84px] block m-auto md:hidden" src="../../../assets/logos/new-logo-imagotipo.svg" alt="isotipo">
                    <img class="w-[88px] h-[88px] hidden md:block" src="../../../assets/images/img/isotipo.svg" alt="isotipo">
                    <h2 class="font-sans text-eggplant-100 text-h500 md:text-h700 py-32 text-center md:text-left">{{ 'register.create_your_account' | translate }}</h2>
                </div>
                <fun-register-person-email
                #registerPersonEmail
                [data]="userData"
                [isRegister]="true"
                profileType="1"
                (sendErrorEvent)="getError()"
                (sendInfoEvent)="getEmailData($event)"
                (acceptConditionsEvent)="getConditions($event)"
                (acceptOffersEvent)="getOffers($event)"
                (checkRefCodeEvent)="checkRefCode($event)">
                </fun-register-person-email>
            </div>
        </div>
        <div class="flex flex-col w-full md:max-w-[50%]">
            <h2 *ngIf="step === 1" class="font-sans text-h600 md:text-h800 bg-gradient-2-text text-center pb-[18px]">{{ title }}</h2>
            <p *ngIf="step === 1" class="font-sans text-eggplant-100/[0.55] text-l text-center">{{ subtitle }}</p>
            <div *ngIf="step === 1" class="flex flex-col gap-20 py-32">
                <div class="question cursor-pointer w-full flex gap-32 justify-between" (click)="selectOption(1)"
                [ngClass]="{'option-selected': profileType === 1, 'option': profileType !== 1}">
                    <div class="flex flex-col py-12 px-24 gap-8">
                        <h4 class="font-sans text-xl text-eggplant-80">{{ 'REGISTER.PUBLIC.P1_TITLE' | translate }}</h4>
                        <p class="font-sans text-l text-gray-40">{{ 'REGISTER.PUBLIC.P1_SUBTITLE' | translate }}</p>
                    </div>
                </div>
                <div class="question cursor-pointer w-full flex gap-32 justify-between" (click)="selectOption(2)"
                [ngClass]="{'option-selected': profileType === 2, 'option': profileType !== 2}">
                    <div class="flex flex-col py-12 px-24 gap-8">
                        <h4 class="font-sans text-xl text-eggplant-80">{{ 'REGISTER.PUBLIC.P2_TITLE' | translate }}</h4>
                        <p class="font-sans text-l text-gray-40">{{ 'REGISTER.PUBLIC.P2_SUBTITLE' | translate }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="(step === 1 || step === 0) && !loading" class="flex w-full justify-end pt-24 pb-48 md:pb-0 md:px-40 md:flex-row md:border-t md:border-eggplant-10">
        <div class="w-full md:w-fit md:flex md:justify-center md:items-center">
            <fun-new-button *ngIf="step === 0" [buttonType]="sendXHR" size="xl" title="{{ 'CANCEL_INVEST.BTN_1' | translate }}" (eventClick)="submiForm()" [classExtra]="' !w-full '" [responsive]="false"></fun-new-button>
            <fun-new-button *ngIf="step === 1" buttonType="primaryDark" size="xl" title="{{ 'CANCEL_INVEST.BTN_1' | translate }}" (eventClick)="setProfileType()" [classExtra]="' !w-full '" [responsive]="false"></fun-new-button>
        </div>
    </div>
</div>
<div class="flex h-full items-center justify-center" *ngIf="step === 2 && !loading">
    <fun-overal-message [text]="textAcceptMail" [image]="imageAcceptMail" [btnList]="btnListAcceptMail" (btnEvent)="removeModal()"></fun-overal-message>
</div>
<div class="w-[980px] max-w-[80%] flex h-full items-center justify-center mx-auto" *ngIf="loading">
    <fun-skeleton-list></fun-skeleton-list>
</div>